import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {AppPlatform} from '../../../shared/constants/platform';
import {AdAccount} from '../../../shared/api/models/ad-accounts';

export const AdAccountsActions = createActionGroup({
	source: 'Account',
	events: {
		'Submit Session Token Accounts': emptyProps(),
		'Load Ad Accounts': props<{ platform: AppPlatform }>(),
		'Load Ad Accounts Success': props<{ data: AdAccount[] }>(),
		'Load Ad Accounts Failure': emptyProps,
		'Pick Ad Account': props<{ data: AdAccount }>(),
		'Remove Ad Account': props<{ data: AdAccount }>(),
		'Pick Ad Accounts': props<{ data: AdAccount[] }>(),
		'Search Ad Accounts': props<{ search: string }>(),
	}
});
